/* eslint-disable-next-line import/prefer-default-export */
export { default as useLocalStorage } from './use-local-storage';
